// Auto-generated from beautyProfilerProducts.csv
// Do not edit manually

import { CSVRow } from '../lib/csvLoader';

export const beautyProfilerProductsData: CSVRow[] = [
  {
    "id": "1",
    "label": "Rose Fétiche",
    "description": "An exquisite rose as a true olfactory homage. An overdose of sensuality that seduces with the playful flirtation of cherry accord and the obsessive richness of a decadent rose.",
    "type": "fetiche",
    "answerOptions": "13,14,17,18,21,22,25,27,29,35,36,40,32,39",
    "boost": "37",
    "keywords": "",
    "olfactiveNotes": "Cherry & Rose"
  },
  {
    "id": "2",
    "label": "Cuir Fétiche",
    "description": "Leather as you've never known it A carnal osmanthus mixed with a silky suede leather. A surprising second-skin fragrance.",
    "type": "fetiche",
    "answerOptions": "13,16,17,18,21,22,25,26,29,33,36,37,39,31",
    "boost": "32",
    "keywords": "",
    "olfactiveNotes": "Osmanthus & Suede leather"
  },
  {
    "id": "3",
    "label": "Lavande Fétiche",
    "description": "An aromatic and sophisticated lavendertrio. A bold experiment where the aromatic brightness of lavender is plunged into the dark powerful embrace of leather.",
    "type": "fetiche",
    "answerOptions": "15,16,18,19,20,23,25,27,30,32,33,34,37,38",
    "boost": "",
    "keywords": "",
    "olfactiveNotes": "Black Leather & Lavender"
  },
  {
    "id": "4",
    "label": "Santal Fétiche",
    "description": "An overdose of addiction, deeply intimate. An overdose of addiction that opens with the fruity temptation of fig and deepens into the warmth of sandalwood.",
    "type": "fetiche",
    "answerOptions": "14,16,18,20,22,24,26,28,29,31,33,36,37,39",
    "boost": "",
    "keywords": "",
    "olfactiveNotes": "Fig & Sandalwood"
  },
  {
    "id": "5",
    "label": "Ambre Fétiche",
    "description": "Amber and tuberose for a never smelled before fragrance, with a very fresh and green top mixed with a warm, addictive amber.",
    "type": "fetiche",
    "answerOptions": "13,17,21,23,25,27,29,31,33,35,37,39,20,15",
    "boost": "",
    "keywords": "",
    "olfactiveNotes": "Tuberose & Amber"
  },
  {
    "id": "6",
    "label": "Ébène Fétiche",
    "description": "A noble Cedarwood contrasted in a surprising way by a splash of irresistible high-quality coconut water.",
    "type": "fetiche",
    "answerOptions": "14,16,19,21,23,25,26,29,30,31,34,35,38,40",
    "boost": "",
    "keywords": "",
    "olfactiveNotes": "Coconut-& Cedarwood"
  },
  {
    "id": "7",
    "label": "Iris Fétiche",
    "description": "The earthiest of our olfactory creations: we revisit the absolute of orris with a woody and textured patchouli for a super luxurious and closest to the earth fragrance.",
    "type": "fetiche",
    "answerOptions": "14,16,19,21,23,25,26,27,30,31,34,35,38,40",
    "boost": "",
    "keywords": "",
    "olfactiveNotes": "Patchouli & Orris"
  },
  {
    "id": "8",
    "label": "Encens Fétiche",
    "description": "A cocktail of warm and cold spices. All the freshness of a cold and sharp pepper combined with the warm and mystical aura of incense.",
    "type": "fetiche",
    "answerOptions": "16,17,18,21,22,24,26,28,30,32,34,36,38,39",
    "boost": "",
    "keywords": "",
    "olfactiveNotes": "Black Pepper & Incense"
  },
  {
    "id": "9",
    "label": "Loubiworld Loubimar",
    "description": "",
    "type": "loubiworld",
    "answerOptions": "16,20,24,26,28,30,32,34,35,36,37,38,39",
    "boost": "",
    "keywords": "",
    "olfactiveNotes": "Lemon & Tuberose"
  },
  {
    "id": "10",
    "label": "Loubiworld Loubifunk",
    "description": "",
    "type": "loubiworld",
    "answerOptions": "15,16,18,19,20,24,28,31,32,34,35,36,38,40",
    "boost": "",
    "keywords": "",
    "olfactiveNotes": "Mandarin & Rose"
  },
  {
    "id": "11",
    "label": "Loubiworld Loubidoo",
    "description": "",
    "type": "loubiworld",
    "answerOptions": "13,14,16,18,19,20,22,24,25,26,28,31,32,34,35,36,38,40",
    "boost": "",
    "keywords": "",
    "olfactiveNotes": "Rose Duo & Cedarwood"
  },
  {
    "id": "12",
    "label": "Loubiworld Loubikiss",
    "description": "",
    "type": "loubiworld",
    "answerOptions": "16,18,19,20,24,28,30,32,34,36,38,39",
    "boost": "",
    "keywords": "",
    "olfactiveNotes": "Tuberose & Cashmeran"
  },
  {
    "id": "13",
    "label": "Loubiworld Loubirouge",
    "description": "",
    "type": "loubiworld",
    "answerOptions": "14,17,18,21,22,25,26,30,35,36,37,38",
    "boost": "",
    "keywords": "",
    "olfactiveNotes": "Orris & Vanilla"
  },
  {
    "id": "14",
    "label": "Loubiworld Loubiraj",
    "description": "",
    "type": "loubiworld",
    "answerOptions": "13,17,21,24,27,29,31,33,36,37",
    "boost": "",
    "keywords": "",
    "olfactiveNotes": "Patchouli & Leather"
  },
  {
    "id": "15",
    "label": "Loubiworld Loubicrown",
    "description": "",
    "type": "loubiworld",
    "answerOptions": "14,18,22,26,29,31,33,35,37,39",
    "boost": "",
    "keywords": "",
    "olfactiveNotes": "Cedar & Tonka Bean"
  },
  {
    "id": "16",
    "label": "Loubiworld Loubicroc",
    "description": "",
    "type": "loubiworld",
    "answerOptions": "13,17,21,23,27,29,31,33,35,37",
    "boost": "",
    "keywords": "",
    "olfactiveNotes": "Balsamic & Sandalwood"
  },
  {
    "id": "17",
    "label": "Loubiworld Loubicharme",
    "description": "",
    "type": "loubiworld",
    "answerOptions": "15,17,23,27,29,31,33,34,35,37",
    "boost": "",
    "keywords": "",
    "olfactiveNotes": "Geranium & Patchouli"
  },
  {
    "id": "18",
    "label": "Loubiworld Loubiprince",
    "description": "",
    "type": "loubiworld",
    "answerOptions": "15,17,23,27,29,31,33,35,37",
    "boost": "",
    "keywords": "",
    "olfactiveNotes": "Cistus & Vetiver"
  },
  {
    "id": "19",
    "label": "Loubiworld Loubiluna",
    "description": "",
    "type": "loubiworld",
    "answerOptions": "13,15,17,21,23,25,27,29,31,33,35,36,37,39",
    "boost": "",
    "keywords": "",
    "olfactiveNotes": "Fig Milk & Papyrus"
  },
  {
    "id": "20",
    "label": "Glamliner Rouge Louboutin 01",
    "description": "",
    "type": "glamliner",
    "answerOptions": "1,9,13,14,17,21,25,26,27",
    "boost": "",
    "keywords": "",
    "olfactiveNotes": ""
  },
  {
    "id": "21",
    "label": "Glamliner Nude Sketch 33",
    "description": "",
    "type": "glamliner",
    "answerOptions": "2,3,4,12,14,16,18,19,20,22,24,25,26,28",
    "boost": "",
    "keywords": "",
    "olfactiveNotes": ""
  },
  {
    "id": "22",
    "label": "Rouge Stiletto Glossy Shine Bare Rococotte 013S",
    "description": "",
    "type": "other-product",
    "answerOptions": "2,10,12,14,16,17,18,19,20,22,24,25,26,28",
    "boost": "",
    "keywords": "",
    "olfactiveNotes": ""
  },
  {
    "id": "23",
    "label": "Rouge Stiletto Glossy Shine Red Walk 146S",
    "description": "",
    "type": "other-product",
    "answerOptions": "1,9,13,17,21,22,26,27",
    "boost": "",
    "keywords": "",
    "olfactiveNotes": ""
  },
  {
    "id": "24",
    "label": "Rouge Stiletto Glossy Shine Rodeo Tomato 155S",
    "description": "",
    "type": "other-product",
    "answerOptions": "1,4,9,11,13,15,17,18,21,23,26,27",
    "boost": "",
    "keywords": "",
    "olfactiveNotes": ""
  },
  {
    "id": "25",
    "label": "Rouge Stiletto Glossy Shine Rouge Louboutin 001S",
    "description": "",
    "type": "other-product",
    "answerOptions": "1,9,10,11,13,14,17,18,21,25,26,27",
    "boost": "",
    "keywords": "",
    "olfactiveNotes": ""
  },
  {
    "id": "26",
    "label": "Rouge Stiletto Vinyl Gloss Rosa intenza 882V",
    "description": "",
    "type": "other-product",
    "answerOptions": "2,3,10,12,14,16,18,19,20,22,24,26,28",
    "boost": "",
    "keywords": "",
    "olfactiveNotes": ""
  },
  {
    "id": "27",
    "label": "Rouge Stiletto Vinyl Gloss Copper Fever 352V",
    "description": "",
    "type": "other-product",
    "answerOptions": "2,4,12,14,16,18,19,20,24,26,28",
    "boost": "",
    "keywords": "",
    "olfactiveNotes": ""
  },
  {
    "id": "28",
    "label": "Rouge Stiletto Vinyl Gloss Rouge Louboutin 001V",
    "description": "",
    "type": "other-product",
    "answerOptions": "1,9,11,13,17,18,21,23,27",
    "boost": "",
    "keywords": "",
    "olfactiveNotes": ""
  },
  {
    "id": "29",
    "label": "Rouge Stiletto Vinyl Gloss Smoky Nudy 392V",
    "description": "",
    "type": "other-product",
    "answerOptions": "2,10,12,14,16,18,19,20,22,24,26,28",
    "boost": "",
    "keywords": "",
    "olfactiveNotes": ""
  },
  {
    "id": "30",
    "label": "Rouge Stiletto Lumi-Matte Nude rose 386L",
    "description": "",
    "type": "other-product",
    "answerOptions": "2,3,10,12,14,16,18,19,22,25,26,28",
    "boost": "",
    "keywords": "",
    "olfactiveNotes": ""
  },
  {
    "id": "31",
    "label": "Rouge Stiletto Lumi-Matte Red Wood 157L",
    "description": "",
    "type": "other-product",
    "answerOptions": "1,9,13,15,17,21,27",
    "boost": "",
    "keywords": "",
    "olfactiveNotes": ""
  },
  {
    "id": "32",
    "label": "Rouge Stiletto Lumi-Matte Peach cabaret 013L",
    "description": "",
    "type": "other-product",
    "answerOptions": "4,10,12,14,16,18,19,22,26,28",
    "boost": "",
    "keywords": "",
    "olfactiveNotes": ""
  },
  {
    "id": "33",
    "label": "Rouge Stiletto Lumi-Matte Rouge Louboutin 001L",
    "description": "",
    "type": "other-product",
    "answerOptions": "1,9,11,13,14,17,21,26,27",
    "boost": "",
    "keywords": "",
    "olfactiveNotes": ""
  },
  {
    "id": "34",
    "label": "Rouge Louboutin Velvet Matte Rouge Louboutin 001M",
    "description": "",
    "type": "other-product",
    "answerOptions": "1,9,11,13,14,17,21,25,26,27",
    "boost": "",
    "keywords": "",
    "olfactiveNotes": ""
  },
  {
    "id": "35",
    "label": "Rouge Louboutin Velvet Matte Epic Brunette 318M",
    "description": "",
    "type": "other-product",
    "answerOptions": "1,9,11,13,15,17,18,21,23,25,26",
    "boost": "",
    "keywords": "",
    "olfactiveNotes": ""
  },
  {
    "id": "36",
    "label": "Rouge Louboutin Velvet Matte Bare Rococotte 013M",
    "description": "",
    "type": "other-product",
    "answerOptions": "2,10,14,16,18,19,22,25,28",
    "boost": "",
    "keywords": "",
    "olfactiveNotes": ""
  },
  {
    "id": "37",
    "label": "Rouge Louboutin Velvet Matte Cameo Mate 313M",
    "description": "",
    "type": "other-product",
    "answerOptions": "3,4,10,12,14,16,18,19,22,25,26,28",
    "boost": "",
    "keywords": "",
    "olfactiveNotes": ""
  },
  {
    "id": "38",
    "label": "Rouge Louboutin Silky Satin Bobo Blush 385",
    "description": "",
    "type": "other-product",
    "answerOptions": "3,10,12,14,16,17,18,20,22,24,25,26,28",
    "boost": "",
    "keywords": "",
    "olfactiveNotes": ""
  },
  {
    "id": "39",
    "label": "Rouge Louboutin Silky Satin Brick Chick 515",
    "description": "",
    "type": "other-product",
    "answerOptions": "1,4,9,11,15,17,18,21,23,26,27",
    "boost": "",
    "keywords": "",
    "olfactiveNotes": ""
  },
  {
    "id": "40",
    "label": "Rouge Louboutin Silky Satin Rouge Louboutin 001",
    "description": "",
    "type": "other-product",
    "answerOptions": "1,9,11,13,14,17,21,25,26,27",
    "boost": "",
    "keywords": "",
    "olfactiveNotes": ""
  },
  {
    "id": "41",
    "label": "Rouge Louboutin Silky Satin Nuance Nu 354",
    "description": "",
    "type": "other-product",
    "answerOptions": "4,12,14,16,18,19,20,22,24,28",
    "boost": "",
    "keywords": "",
    "olfactiveNotes": ""
  },
  {
    "id": "42",
    "label": "Oud Fétiche",
    "description": "A sensual olfactory composition that unveils the luscious juiciness of white Peach, both radiant and velvety, embracing the dark, smoky elegance of Oud. This encounter leaves a trail of opulence and irresistible depth.",
    "type": "fetiche",
    "answerOptions": "13,14,17,18,21,22,25,26,27,29,31,33,35,37,39",
    "boost": "31",
    "keywords": "",
    "olfactiveNotes": "White Peach & Oud"
  }
];
